import {
  dashboard_card_rows,
  dashboard_hero,
  dsar_status_options,
  dsar_type_options,
  pi_inventory_status_options,
  privacy_tabs,
  processing_basis_options,
  processing_status_options,
  sensitivity_options
} from './data_privacy_builders';
import { data_privacy_computed, data_privacy_form_factories, data_privacy_hooks, data_privacy_methods, data_privacy_seed_sequences, data_privacy_watch } from './data_privacy_helper';
import { data_privacy_modal_methods } from './data_privacy_modal';
import { consent_rows, cross_border_rows, dsar_rows, incident_rows, pi_inventory_rows, pia_rows, processing_rows, retention_rows, sharing_rows } from './data_privacy_rows';

export default {
  name: 'ComplyonDataPrivacy',
  data: () => ({
    privacy_tabs, dashboard_hero, dashboard_card_rows, sensitivity_options, pi_inventory_status_options, processing_basis_options, processing_status_options, dsar_type_options, dsar_status_options,
    pi_inventory_rows, processing_rows, dsar_rows, consent_rows, sharing_rows, pia_rows, retention_rows, cross_border_rows, incident_rows,
    active_tab: 'dashboard', pi_inventory_modal_open: false, pi_inventory_edit_index: null, pi_inventory_form: data_privacy_form_factories.create_pi_inventory_form(), active_pi_inventory_ref: null, pi_inventory_sequence: data_privacy_seed_sequences.pi_inventory_sequence,
    processing_modal_open: false, processing_edit_index: null, processing_form: data_privacy_form_factories.create_processing_form(), active_processing_ref: null, processing_sequence: data_privacy_seed_sequences.processing_sequence,
    dsar_modal_open: false, dsar_edit_index: null, dsar_form: data_privacy_form_factories.create_dsar_form(), dsar_sequence: data_privacy_seed_sequences.dsar_sequence
  }),
  computed: { ...data_privacy_computed },
  methods: { ...data_privacy_methods, ...data_privacy_modal_methods },
  mounted: data_privacy_hooks.mounted,
  beforeDestroy: data_privacy_hooks.beforeDestroy,
  watch: data_privacy_watch
};
